var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-800"},[_c('Navbar'),_c('div',{staticClass:"lg:flex mb-4"},[_vm._v("\n        File not found!\n        "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go Home")])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }